import React from 'react';
import { formatText } from 'core/i18n';
import ModalBox from 'components/modalBox/modalBox';
import penguinHolders from 'assets/icons/penguin-two-holders.svg';
import './jointHolderAdviseModal.scss';
import PropTypes from 'prop-types';

export const JointHolderAdviseModal = ({ onClickMainAction }) => (
    <ModalBox
        closeButton={false}
        closeIcon={false}
        bsSize="large"
        mainAction={onClickMainAction}
        defaultOpen={true}
        openButton={false}
        modalTitle={formatText('messagesScreen-depositTitleMulti')}
        textButtonMainAction={formatText('button-understood')}
        type="jointHolder-advise-modal"
    >
        <div className="jointHolder-advise-modal-body">
            <img src={penguinHolders} alt="penguin-two-holders" />
            <p>{formatText('messagesScreen-depositDescriptionMulti')}</p>
        </div>
    </ModalBox>
);

JointHolderAdviseModal.propTypes = {
    onClickMainAction: PropTypes.func,
};
